import { render, staticRenderFns } from "./xgpassword.vue?vue&type=template&id=5371befc&scoped=true"
import script from "./xgpassword.vue?vue&type=script&lang=js"
export * from "./xgpassword.vue?vue&type=script&lang=js"
import style0 from "./xgpassword.vue?vue&type=style&index=0&id=5371befc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5371befc",
  null
  
)

export default component.exports